import React from 'react'
import { SVGIconProps } from '../types'
const SvgPause = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M6 19h4V5H6zm8-14v14h4V5z" />
  </svg>
)
export default SvgPause
